import { render, staticRenderFns } from "./ClinicHospitalsDialog.vue?vue&type=template&id=6ca9438d"
import script from "./ClinicHospitalsDialog.vue?vue&type=script&lang=js"
export * from "./ClinicHospitalsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports